import { render, staticRenderFns } from "./BookableRoomCard.vue?vue&type=template&id=a1fab72a&scoped=true&"
import script from "./BookableRoomCard.vue?vue&type=script&lang=js&"
export * from "./BookableRoomCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fab72a",
  null
  
)

export default component.exports